module.exports = __webpack_public_path__ + "img/thanhnguyen.61e117ac.png";